export function routes($stateProvider) {
  $stateProvider
    .state('app.oportunidade', {
      url: '/oportunidade',
      abstract: true,
      template: '<div ui-view></div>'
    })
    .state('app.oportunidade.list', {
      url: '?{page:int}&{items:int}&{state:int}&order&sort&filter',
      title: 'Gestão de Oportunidades',
      template: require('./directory/directory.view.html'),
      controller: 'OportunidadeListController',
      controllerAs: 'vm',
      role: 'oportunidadeRead',
      params: {
        state: {
          value: 1,
          dynamic: true
        },
        page: {
          value: 1,
          dynamic: true
        },
        items: {
          value: 20,
          dynamic: true
        },
        order: {
          value: "id",
          dynamic: true
        },
        sort: {
          value: "desc",
          dynamic: true
        },
        filter: {
          dynamic: true
        }
      }
    })
    .state('app.oportunidade.details', {
      url: '/{id}',
      title: 'Oportunidade',
      controller: 'OportunidadeDetailsController',
      controllerAs: 'vm',
      template: require('./details/details.view.html'),
      role: 'oportunidadeRead'
    })
    .state('app.oportunidade.new', {
      url: '/nova',
      title: 'Adicionar Oportunidade',
      template: require('./new/new.view.html'),
      controller: 'OportunidadeCreateOportunidadeController',
      controllerAs: 'vm',
      role: 'oportunidadeCreate'
    })
    .state('app.oportunidade.new.1', {
      template: require('./new/oportunidade.1.form.html')
    })
  ;
}

routes.$inject = ['$stateProvider'];
